<app-header-menu></app-header-menu>
<div class="d-flex flex-column h-100">
    <router-outlet class="content"></router-outlet>
    <app-footer class="foot"></app-footer>
</div>
